import { type FC, useState } from "react";
import { useSWRData } from "@root/shared/hooks/useSWRData";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";
import { Presentation } from "./Presentation";

type Props = {
  fetchUrl: string;
  settingSearchConditionsPath: string;
};

type SearchCondition = {
  id: string;
  searchConditionName: string;
  clientShopName: string;
  searchConditionDetail: string;
  searchPath: string;
};

export const ScoutsSavedSearchConditions: FC<Props> = ({
  fetchUrl,
  settingSearchConditionsPath,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClickShowSearchConditionsButton = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => setIsModalOpen(false);

  const { data: searchConditions } = useSWRData<SearchCondition[]>({
    url: fetchUrl,
    options: { onError: (error: Error) => sendErrorLog(error) },
  });

  if (!searchConditions || !searchConditions.length) return null;

  return (
    <Presentation
      settingSearchConditionsPath={settingSearchConditionsPath}
      searchConditions={searchConditions}
      onClickShowSearchConditionsButton={handleClickShowSearchConditionsButton}
      isModalOpen={isModalOpen}
      onCloseModal={handleCloseModal}
    />
  );
};
